// 葡语
const pt = {
    // 首页-激活说明
    activateExplain: {
        title: 'Ative sua garantia estendida e receba um presente especial para você',
        desp: 'Condição aplicada: Para se qualificar, os clientes concordam em compartilhar sua experiência de compra com nossos produtos adquiridos que estão em uso ativo há pelo menos uma semana.',
        conditions: [
            'Somente para clientes que compraram os produtos na Amazon',
            'Cada cliente pode reivindicar apenas um PRESENTE GRATUITO para um produto. (O que significa que, não importa quantas vezes você compre o mesmo produto, você poderá obter apenas um presente GRÁTIS).',
        ]
    },
    // 首页-激活表单
    activateForm: {
        title: 'Ative sua garantia estendida e ganhe o presente GRATUITO AGORA!',
        desp: 'Disponível apenas para clientes existentes',
        name: 'Nome',
        namePlaceholder: `Digite o nome do destinatário`,
        nameErrMsg: `O nome está incorreto.`,
        email: 'Email',
        emailPlaceholder: `Digite seu email`,
        emailErrMsg: `O email está incorreto.`,
        verifCode: 'Código de verificação',
        verifCodePlaceholder: `Digite seu código de verificação`,
        verifCodeErrMsg: `Código de verificação incorreto.`,
        btnSendCode: `Envie o código de verificação`,
        countdownMsg: `Reenviar em {countdown} segundos`,
        orderId: 'ID do pedido',
        orderIdPlaceholder: `Digite seu ID do pedido`,
        orderIdErrMsg: `O ID do pedido está incorreto.`,
        orderAppliedError: `Este pedido já solicitou um presente.`,
        skuAppliedError: `O presente deste pedido foi coletado.`,
        orderIdHelp: 'Como encontrar o ID do seu pedido?',
        btnAactivate: 'Ative agora',
        statement: 'Certamente não compartilharemos suas informações pessoais com outras pessoas.',
        orderIdErrPopoverMsg: 'Se o seu ID do pedido estiver correto, entre em contato com o serviço de atendimento ao cliente por e-mail. Ajudaremos você a ativar a garantia estendida e confirmar se o evento cobre seu mercado.',
        priceErrPopoverMsg: 'Lamentamos informar que este pedido usou nosso menor desconto, se houver algum problema, entre em contato conosco por e-mail.'
    },
    // 通用弹框
    commonModal: {
        msg: `{msg}`,
        msgContents: [
            `O nome do destinatário não pode corresponder ao pedido`,
            `Se a revisão da Amazon está concluída?`,
            `Deseja continuar na Amazon para revisar?`
        ],
        btnRewrite: 'REESCREVER',
        btnNo: 'NÃO',
        btnYes: 'SIM'
    },
    // 选择礼物
    chooseGift: {
        title: 'Agora, escolha o presente que você deseja.',
        modalTitle: 'Desculpe, o presente que você selecionou não está mais disponível. Escolha novamente',
        btnWant: 'QUERO ISSO',
        btnStockout: 'FORA DE ESTOQUE'
    },
    // 订单信息
    orderInfo: {
        title: 'Parabéns! Sua garantia estendida está ativada!',
        desp: 'O que você obterá',
        orderTitle: 'Informações do seu pedido',
        orderId: 'ID do pedido',
        productASIN: 'Produto ASIN',
        productName: 'Título do Produto',
        address: 'Endereço',
        aboutGift: [
            'Sobre o presente',
            'Sem custos de envio, sem taxas ocultas, sem necessidade de cartão de crédito.',
            '4 etapas simples para obtê-lo (menos de 5 minutos).',
            'O presente será enviado a você em 2 a 5 dias úteis após a reivindicação.'
        ],
        btnWant: 'QUERO ISSO'
    },
    // 步骤1
    stepOne: {
        title: 'Etapa 1 de 4: Uma breve pesquisa sobre sua compra.',
        questionList: [{
                id: 1,
                select_type: 'radio',
                name: 'sex',
                title: '1. Eu sou um ...?',
                option: [{
                        txt: 'Fêmea',
                        value: 0
                    },
                    {
                        txt: 'Masculino',
                        value: 1
                    },
                    {
                        txt: 'Não tenho certeza',
                        value: 2
                    }
                ]
            },
            {
                id: 2,
                select_type: 'radio',
                name: 'age',
                title: `2. Qual é a sua faixa etária?`,
                option: [{
                        txt: 'Menos de 20',
                        value: 0
                    },
                    {
                        txt: '20-30',
                        value: 1
                    },
                    {
                        txt: '30-40',
                        value: 2
                    },
                    {
                        txt: '40-50',
                        value: 3
                    },
                    {
                        txt: '50-60',
                        value: 4
                    },
                    {
                        txt: 'Mais de 60',
                        value: 5
                    }
                ]
            },
            {
                id: 3,
                select_type: 'radio',
                name: 'reason',
                title: '3. Por que você nos escolheu?',
                option: [{
                        txt: 'Marca',
                        value: 0
                    },
                    {
                        txt: 'Projeto',
                        value: 1
                    },
                    {
                        txt: 'Preço',
                        value: 2
                    },
                    {
                        txt: 'Característicos',
                        value: 3
                    },
                    {
                        txt: 'Avaliações',
                        value: 4
                    },
                    {
                        txt: 'Outras razões',
                        value: 5,
                        placeholder: 'Digite um motivo'
                    }
                ]
            },
        ],
        btnNext: 'PRÓXIMA ETAPA'
    },
    // 步骤2
    stepTwo: {
        title: 'Etapa 2 de 4: conte-nos sua experiência sobre o produto.',
        despOne: `Classificação geral?`,
        despTwo: `Deixe-nos saber como nossos produtos estão funcionando para você.`,
        notice: `(Digite pelo menos 10 caracteres)`,
        commentPlaceholder: 'Digite seu comentário',
        commentErrMsg: `As palavras de comentários não podem exceder 20.000`,
        btnNext: 'PRÓXIMA ETAPA',
        btnPrev: 'ETAPA ANTERIOR'
    },
    // 步骤3
    stepThree: {
        title: 'Passos 3 de 4: Compartilhe sua experiência de compra com outras pessoas.',
        desp: 'APENAS leva alguns segundos. Seus comentários ajudariam outros clientes a tomar uma melhor decisão de compra. Obrigado pela sua compreensão e apoio.',
        commentTitle: 'Os teus comentários',
        defaultComment: 'Eu gosto muito do seu produto!',
        btnCopyPost: 'CLIQUE AQUI PARA COPIAR E POSTAR SUA REVISÃO NA AMAZÔNIA'
    },
    // 步骤4
    stepFour: {
        title: 'Etapa 4 de 4: confirme seu endereço.',
        desp: 'O que você obterá',
        fullName: 'Nome completo',
        fullNamePlaceholder: `Digite seu nome completo`,
        fullNameErrMsg: `O nome completo está incorreto`,
        phone: 'Telefone',
        phonePlaceholder: `Digite seu telefone`,
        phoneErrMsg: `O telefone está incorreto`,
        email: 'Email',
        emailPlaceholder: `Digite seu email`,
        emailErrMsg: `O email está incorreto`,
        address: 'Endereço',
        addressPlaceholder: `Digite seu endereço`,
        addressErrMsg: `Endereço incorreto`,
        streetPlaceholder:`Endereço`,
        apartmentPlaceholder:`Apartamento / Unidade`,
        cityPlaceholder:`Cidade`,
        regionPlaceholder: `Selecione o estado`,
        countryPlaceholder: `Escolha um país`,
        postcode: 'Código Postal',
        postcodePlaceholder: `Digite seu CEP`,
        postcodeErrMsg: `Código postal incorreto`,
        btnComfirm: 'CONFIRME'
    },
    // 完成礼物申请
    completeApplication: {
        title: `Você concluiu o aplicativo de brinde`,
        msgs: [
            'O presente grátis será enviado em 2-5 dias úteis.',
            'O presente gratuito será enviado para seu e-mail ',
            ' em 2-5 dias úteis.Atenciosamente, obrigado por adquirir nossos produtos, e haverá um contato dedicado da equipe de pós-venda.',
            'Quaisquer outros problemas que você possa ter, entre em contato com nosso serviço ao cliente por e-mail ou visite nosso site oficial.',
            'Como você não está 100% satisfeito com nossos produtos, entre em contato com o nosso serviço de atendimento ao cliente por e-mail ou visite nosso site oficial, haverá profissionais para atendê-lo. 100% de satisfação do cliente é a nossa garantia!'
        ],
        btnComfirm: 'CONFIRME'
    },
    // 获取订单号指导
    guide: {
        title: 'Como encontrar o seu ID do pedido?',
        desps: [
            `Etapa 1: faça login na sua conta Amazon e clique em "Seu pedido" na página Conta e lista`,
            `Etapa 2: clique em "Detalhes do pedido" na ordem correta`,
            `Etapa 3: você verá o ID do seu pedido`
        ],
        btnOK: 'Está bem'
    }
}

export default pt